
import Arrow from "@/components/svg/Arrow.vue";

import { Product } from "@/entities/domain/Match/Product";
import Company from "@/entities/domain/Company/Company";
import { StylingVariant, ResultButtonAction, ProductCardVersion } from "@/entities/enums/QuizConfigEnums";
import { defineComponent, PropType } from "vue";
import ProductCard from "../Result/ProductCard.vue";
import ProductCardV2 from "@/components/BaseComponents/ProductCardV2.vue";
import QuizService from "@/services/QuizService";
import { Chatbot } from "@/entities/domain/Chatbot/Chatbot";
import { Message } from "@/entities/domain/Chatbot/Message";
import { MessageSender } from "@/entities/enums/ChatbotEnums";
import { ProductFeedbackCause } from "@/entities/enums/ProductFeedbackCause";
import { ProductFilter, Operator } from "@/entities/domain/Match/ProductListFilter";
import { Answer } from "../../../entities/domain/Quiz/Answer"
import QuerySelectorAll from "@/utils/QuerySelectorAll";
import QrcodeVue from 'qrcode.vue';

export default defineComponent({
	name: "SingleMessage",
	props: {
		message: {
			type: Object as PropType<Message>,
			required: true,
		},
		productRecommendation: {
			type: Object as PropType<Product[]>,
		},
		company: {
			type: Object as PropType<Company>,
			required: true,
		},
		chatbot: {
			type: Object as PropType<Chatbot>,
			required: true,
		},
		avatar: {
			type: String,
			required: true,
		},
		isExpertQuiz: {
			type: Boolean,
			required: true,
		}
	},
	data() {
		return {
			localChatbot: { ...this.chatbot } as Chatbot,
			firstV2CardFlipped: true,
		}
	},
	created() {
		this.localChatbot = { ...this.chatbot } as Chatbot;
	},
	mounted() {

		// this.$nextTick(() => {
		// 	let maxCardHeight = 0;
		// 	const cards = QuerySelectorAll('.productcard .card');
		// 	const innerCards = QuerySelectorAll('.productcard .card .cardInner');
		// 	innerCards?.forEach((card: any) => {
		// 		const cardHeight = card.offsetHeight;
		// 		if (cardHeight > maxCardHeight) maxCardHeight = cardHeight;
		// 	});

		// 	maxCardHeight += 20;

		// 	if(maxCardHeight > 450)
		// 		maxCardHeight = 450;

		// 	cards?.forEach((card: any) => {
		// 		card.style.minHeight = maxCardHeight + 'px';
		// 	});
		// });

		setTimeout(() => {
			this.firstV2CardFlipped = false;
		}, 1000);
	},
	computed: {
		isMessageSenderWilli() {
			return this.message.Sender === MessageSender.WILLI;
		},
		stylingVariant() {
			return StylingVariant.CHATBOT;
		},
		filteredProductResults() {
			if (!this.localChatbot.ProductFilter)
				return this.productRecommendation;

			return this.localChatbot.ProductFilter.FilterProductList(this.productRecommendation ?? [], this.company.CompanyQuizConfig.AdvancedProductResultFiltering);
		},
		chatbotTexts() {
			return this.company.FrontendDesign?.ProductWizard?.TextConventions ?? undefined;
		}
	},
	components: { ProductCard, Arrow, ProductCardV2, QrcodeVue },
	methods: {
		toggleAnswerSelection(answer: Answer) {
			answer.selected = !answer.selected;
		},
		sendMultipleAnswers() {
			const selectedAnswers: any = this.$props.message.AnswerSelection?.filter(answer => answer.selected);
			if (selectedAnswers && selectedAnswers.length > 0) {
				// Set the 'Text' property of each selected answer to the comma-separated string
				const selectedTexts: string[] = selectedAnswers.map(answer => answer.Text);

				// Create a single object with Text as comma-separated string
				const finalAnswer: Answer = {
					...selectedAnswers[0],  // Use properties from the first selected answer
					Text: selectedTexts.join(', '),  // Set Text as comma-separated string
					text: selectedTexts.join(', '),  // Set text as comma-separated string
				};
				// Call the chatbot method with the modified answers
				this.$props.chatbot.SetAnswerForQuiz(
					this.$props.company,
					finalAnswer,
					// this.$props.company.CompanyQuizConfig.ExtraChatBotQuiz,
					(this.$props.isExpertQuiz === true ? this.$props.company.CompanyQuizConfig.ExtraChatBotQuiz : this.$props.company.CompanyQuizConfig.ExpertQuiz),
					this.$props.isExpertQuiz
				);

				// Reset selected state for answers
				selectedAnswers.forEach(answer => {
					answer.selected = false;
				});
			} else {
				// Provide a message or take any other action if no answers are selected
				console.warn('Please select at least one answer before clicking "Select Multiple".');
			}
		},
		productClicked(product: Product) {
			if (this.company.CompanyQuizConfig.ResultButtonAction === ResultButtonAction.SAVEMODE || this.company.CompanyQuizConfig.ResultButtonAction === ResultButtonAction.SHOWQRCODE 
			|| this.company.CompanyQuizConfig.ResultButtonAction === ResultButtonAction.OPENNAVIGATIONMAP
			) {
				this.$emit("productClicked", product);
			}
			else {
				window.open(product.Handle, "_blank")?.focus();
			}
			QuizService.sendEvent(JSON.stringify({ source: "chatbot", product: product.Id }), "LinkOpened")
		},
		scrollProductCards(direction: number) {
			const productcardContainer = this.$el.querySelector('.productcard') as HTMLElement;
			const productcard = productcardContainer.querySelector('.productcard > :first-child') as HTMLElement;
			const productcardWidth = productcard?.offsetWidth ?? 0;
			const productcardMargin = parseFloat(getComputedStyle(productcard).marginRight) + parseFloat(getComputedStyle(productcard).marginLeft);
			const scrollAmount = direction * (productcardWidth + productcardMargin);
			const containerWidth = productcardContainer.offsetWidth;
			const maxScrollPosition = productcardContainer.scrollWidth - containerWidth;
			let newScrollPosition = productcardContainer.scrollLeft + scrollAmount;

			if (newScrollPosition < 0) {
				newScrollPosition = 0;
			} else if (newScrollPosition > maxScrollPosition) {
				newScrollPosition = maxScrollPosition;
			} else {
				const cardIndex = Math.floor(newScrollPosition / (productcardWidth + productcardMargin));
				newScrollPosition = cardIndex * (productcardWidth + productcardMargin);
			}

			productcardContainer.scrollTo({
				left: newScrollPosition,
				behavior: 'smooth',
			});
		},
		productFeedbackCauseSelected(feedbackData: { Product: Product, Cause: ProductFeedbackCause }) {
			// Save Feedback  as ProductFilters
			this.localChatbot.ProductFilter!.ProductFilterOptions = [
				...this.localChatbot.ProductFilter!.ProductFilterOptions,
				new ProductFilter({
					PropertyName: "Id",
					Operator: Operator.NotEqual,
					ValueToCompare: feedbackData.Product.Id
				} as ProductFilter)
			]

			this.localChatbot.ProductFilter!.ProductFilterOptions = [
				...this.localChatbot.ProductFilter!.ProductFilterOptions,
				new ProductFilter({
					PropertyName: feedbackData.Cause,
					Operator: Operator.NotEqual,
					ValueToCompare: feedbackData.Product[feedbackData.Cause]
				} as ProductFilter)
			]
		},
		singleActionClicked(answer: Answer) {
			if( !answer.NextQuestion && answer.NextQuiz !== this.company.CompanyQuizConfig.ExtraChatBotQuiz && answer.NextQuiz !== this.company.CompanyQuizConfig.ExpertQuiz)
				this.$emit("hardStartQuiz");
			else{
				const currentQuiz = this.isExpertQuiz ? this.company.CompanyQuizConfig.ExpertQuiz : this.company.CompanyQuizConfig.ExtraChatBotQuiz;
				
				this.chatbot.SetAnswerForQuiz(this.company, answer, currentQuiz, this.isExpertQuiz); 
			}
		},
		openCouponUrl() {
			window.open(this.company.CompanyQuizConfig.CouponUrl, "_blank")?.focus();
		}
	},
});
